import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

const MONTHS_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

export const getNotificationTypeLabel = (tipo) => {
  if (tipo === 'respuesta') {
    return 'Respuesta';
  }

  if (tipo === 'sistema') {
    return 'Sistema';
  }

  return 'Aviso';
};

export const formatNotificationTime = (value) => {
  if (!value) {
    return '';
  }

  const normalized = value.includes('T') ? value : value.replace(' ', 'T');
  const date = new Date(normalized);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) {
    return 'Ahora';
  }

  if (diffMins < 60) {
    return diffMins === 1 ? 'Hace 1 min' : `Hace ${diffMins} mins`;
  }

  const diffHours = Math.floor(diffMins / 60);

  if (diffHours < 24) {
    return diffHours === 1 ? 'Hace 1 hora' : `Hace ${diffHours} horas`;
  }

  const sameYear = date.getFullYear() === now.getFullYear();
  const monthLabel = MONTHS_SHORT[date.getMonth()] || 'mes';

  if (sameYear) {
    return `${date.getDate()} de ${monthLabel}`;
  }

  return `${date.getDate()} de ${monthLabel} ${date.getFullYear()}`;
};

export const fetchUserNotifications = (usuarioId) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Debes iniciar sesión para ver tus notificaciones.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('Las notificaciones requieren conexión con el servidor.'));
  }

  return api
    .post('/perfil_notificaciones_listar.php', { usuario_id: usuarioId })
    .then((response) => getApiData(response, 'No se pudieron cargar las notificaciones.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const getNotificationInitials = (notification) => {
  const source = notification.autor_nombre || notification.mensaje || 'S';

  return source
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();
};
